"use client";

import React from "react";
import { Activity, Info, Syringe } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EstimatedTotalOutOfPocket() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="estimated-total-outofpocket" className="bg-background py-16 md:py-24">
      <div ref={ref} className={`container mx-auto max-w-5xl px-4 transition-all duration-700 ease-in-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <div className="mb-12 text-center">
          <h2 className="font-default text-3xl font-bold text-foreground md:text-4xl">
            Estimated Total Out-of-Pocket
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-muted-foreground">
            Transparent pricing estimates to help you plan your healthcare journey with confidence.
          </p>
        </div>

        <div className="mb-10 grid gap-8 md:grid-cols-2">
          {}
          <Card className="border-t-4 border-t-[var(--primary)] shadow-md transition-shadow hover:shadow-lg">
            <CardHeader className="pb-4">
              <div className="mb-2 flex items-center gap-3">
                <div className="rounded-md bg-[var(--primary)]/10 p-2">
                  <Syringe className="size-6 text-[var(--primary)]" />
                </div>
                <CardTitle className="font-default text-xl">
                  Surgical Procedures
                </CardTitle>
              </div>
            </CardHeader>
            <CardContent>
              <div className="flex items-baseline gap-1">
                <span className="text-4xl font-bold text-[var(--primary)] md:text-5xl">
                  €1,200
                </span>
                <span className="text-xl font-medium text-muted-foreground">
                  - €2,500
                </span>
              </div>
              <p className="mt-3 text-sm text-muted-foreground">
                Estimated range depending on the specific procedure and individual requirements.
              </p>
            </CardContent>
          </Card>

          {}
          <Card className="border-t-4 border-t-[var(--ring)] shadow-md transition-shadow hover:shadow-lg">
            <CardHeader className="pb-4">
              <div className="mb-2 flex items-center gap-3">
                <div className="rounded-md bg-[var(--ring)]/10 p-2">
                  <Activity className="size-6 text-[var(--ring)]" />
                </div>
                <CardTitle className="font-default text-xl">
                  Pain Management
                </CardTitle>
              </div>
            </CardHeader>
            <CardContent>
              <div className="flex items-baseline gap-1">
                <span className="text-4xl font-bold text-[var(--ring)] md:text-5xl">
                  €300
                </span>
                <span className="text-xl font-medium text-muted-foreground">
                  - €500
                </span>
              </div>
              <p className="mt-3 text-sm text-muted-foreground">
                Estimated range for standard pain management consultations and targeted treatments.
              </p>
            </CardContent>
          </Card>
        </div>

        {}
        <Alert className="mb-10 items-center border-none bg-secondary shadow-sm">
          <Info className="size-5 shrink-0 text-secondary-foreground" />
          <AlertDescription className="text-sm leading-relaxed text-secondary-foreground md:text-base">
            <strong>Please note:</strong> These estimates are based on standard HSE DRG rates and typical treatment paths. Your actual out-of-pocket costs may vary. Our team is here to assist you with detailed pricing and funding options tailored to your specific needs.
          </AlertDescription>
        </Alert>

        {}
        <div className="flex justify-center">
          <Link to="#">
            <Button size="lg" className="h-12 px-8 text-base font-semibold">
              Book a consultation
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}